import { render, staticRenderFns } from "./DetailsTicketImages.vue?vue&type=template&id=551691d5"
import script from "./DetailsTicketImages.vue?vue&type=script&lang=ts"
export * from "./DetailsTicketImages.vue?vue&type=script&lang=ts"
import style0 from "./DetailsTicketImages.vue?vue&type=style&index=0&id=551691d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports